import { render, staticRenderFns } from "./PlatformDataTable.vue?vue&type=template&id=bf45a508&scoped=true"
import script from "./PlatformDataTable.vue?vue&type=script&lang=js"
export * from "./PlatformDataTable.vue?vue&type=script&lang=js"
import style0 from "./PlatformDataTable.vue?vue&type=style&index=0&id=bf45a508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf45a508",
  null
  
)

export default component.exports